import { getTypeColor, getTypeTextColor } from '../data/typeColors';

const SIZE_STYLES = {
  sm: { padding: '2px 8px',  fontSize: '0.75rem' },
  md: { padding: '3px 12px', fontSize: '0.85rem' },
  lg: { padding: '4px 16px', fontSize: '1rem'    },
};

export default function TypeBadge({ type, size = 'md' }) {
  const { padding, fontSize } = SIZE_STYLES[size] ?? SIZE_STYLES.md;
  return (
    <span
      style={{
        backgroundColor: getTypeColor(type),
        color: getTypeTextColor(type),
        padding,
        fontSize,
        borderRadius: '9999px',
        fontWeight: 600,
        textTransform: 'capitalize',
        letterSpacing: '0.03em',
        display: 'inline-block',
        lineHeight: 1.4,
      }}
    >
      {type}
    </span>
  );
}
